import { AgentModelSelection } from './AgentChat.types';

export type AgentDevModelOption = AgentModelSelection & {
  key: string;
  label: string;
  description: string;
};

/** Curated list for local model comparison — not shipped to production DJs. */
export const AGENT_DEV_MODELS: AgentDevModelOption[] = [
  {
    key: 'composer-2.5-fast',
    id: 'composer-2.5',
    params: [{ id: 'fast', value: 'true' }],
    label: 'Composer 2.5 Fast',
    description:
      'Current default. Tuned for DJ tools; fast but pricey output ($15/M).',
  },
  {
    key: 'composer-2.5-standard',
    id: 'composer-2.5',
    params: [{ id: 'fast', value: 'false' }],
    label: 'Composer 2.5 Standard',
    description:
      'Same model, slower turns. Cheapest Cursor-native tier ($0.50/$2.50).',
  },
  {
    key: 'gemini-3.7-flash',
    id: 'gemini-3.7-flash',
    label: 'Gemini 3.7 Flash',
    description:
      'Google speed tier. Snappy replies, low output cost ($3.50/M).',
  },
  {
    key: 'gpt-5.6-luna',
    id: 'gpt-5.6-luna',
    label: 'GPT-5.6 Luna',
    description:
      'Cheapest GPT-5.6 ($0.20/$1.20). Good for quick library questions.',
  },
  {
    key: 'gpt-5.4-mini',
    id: 'gpt-5.4-mini',
    label: 'GPT-5.4 Mini',
    description:
      'Smaller GPT-5.4 ($0.75/$4.50). Balance of speed and answer quality.',
  },
];

export const DEFAULT_AGENT_DEV_MODEL = AGENT_DEV_MODELS[0];

export const toModelSelection = (
  option: AgentDevModelOption,
): AgentModelSelection => ({
  id: option.id,
  ...(option.params?.length ? { params: option.params } : {}),
});

export const matchDevModel = (
  selection: AgentModelSelection,
): AgentDevModelOption => {
  const paramsKey = (selection.params ?? [])
    .map((param) => `${param.id}=${param.value}`)
    .sort()
    .join('|');

  return (
    AGENT_DEV_MODELS.find((option) => {
      if (option.id !== selection.id) return false;
      const optionKey = (option.params ?? [])
        .map((param) => `${param.id}=${param.value}`)
        .sort()
        .join('|');
      return optionKey === paramsKey;
    }) ?? DEFAULT_AGENT_DEV_MODEL
  );
};
